import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getOrgStructure } from "../../api/api";
import { Spinner } from "react-bootstrap";

const OrgStructure = () => {
  const [loading, setLoading] = useState(false);
  const [imgUrl, setImgUrl] = useState("");
  const { i18n, t } = useTranslation();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      //Runs only on the first render
      try {
        const hrFilesResponse = await getOrgStructure({
          language: i18n.language,
          id: i18n.language != "en" ? "27" : "28",
        });
        setImgUrl(
          process.env.REACT_APP_CMS +
            hrFilesResponse.data.attributes.file.data.attributes.url
        );
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []); // Empty dependency array to run only once

  return (
    <div style={{ position: "relative", textAlign: "center" }}>
      {/* Loading Spinner */}
      {loading && (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      )}

      {/* Image */}
      <img
        width="100%"
        alt="Tatweer_Organization_Structure"
        src={imgUrl}
        onLoad={() => setLoading(false)} // Hide spinner once the image loads
        style={{ display: loading ? "none" : "block" }} // Hide image until loaded
      />
    </div>
  );
};

export default OrgStructure;
